import React, { useState } from 'react';
import { X, Check } from 'lucide-react';
const comparisons = [{
  sin: 'Perdido frente a ideación suicida sin método claro',
  con: 'Protocolo de riesgo suicida en 4 pasos listo para usar'
}, {
  sin: 'Sin saber qué documentar para no exponerte',
  con: 'Plantillas de notas y consentimientos listas para firmar'
}, {
  sin: 'No sabés qué plazo tenés para notificar al juez',
  con: 'Tabla de plazos con semáforo visual: sabés qué y cuándo'
}, {
  sin: 'Sin protocolo ante agitación severa: improvisás',
  con: 'Tabla de sedación por nivel y perfil con dosis exactas'
}, {
  sin: 'Libros en inglés de 800 páginas que no aplicás',
  con: '6 tomos en español rioplatense listos para usar'
}, {
  sin: 'No sabés manejar al familiar que amenaza con denunciar',
  con: 'Script exacto de comunicación con registro legal'
}, {
  sin: 'Documentación incompleta = exposición ante sumario',
  con: 'Sistema de documentación preventiva diaria'
}, {
  sin: 'Cero diferenciación frente a otros residentes',
  con: 'Razonamiento que los jefes notan desde el primer turno'
}];
export function Comparison() {
  const [view, setView] = useState<'sin' | 'con'>('sin');
  return <section className="py-8 md:py-20 bg-white" data-id="element-71">
      <div className="max-w-5xl mx-auto px-4" data-id="element-72">
        <div className="text-center mb-6 md:mb-12" data-id="element-73">
          <h2 className="text-[11px] md:text-sm font-bold text-brand-mid tracking-wider uppercase mb-1.5" data-id="element-74">
            LA REALIDAD
          </h2>
          <h3 className="font-heading text-[22px] md:text-4xl text-brand-dark mb-2 md:mb-4" data-id="element-75">
            ¿Cuánto cuesta NO tenerlo?
          </h3>
        </div>

        {/* Desktop View */}
        <div className="hidden md:block bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-76">
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200" data-id="element-77">
            <div className="p-4 text-center font-bold text-red-600 uppercase tracking-wider text-sm" data-id="element-78">
              SIN EL MEGAPACK
            </div>
            <div className="p-4 text-center font-bold text-green-600 uppercase tracking-wider text-sm border-l border-gray-200" data-id="element-79">
              CON EL MEGAPACK
            </div>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-80">
            {comparisons.map((row, idx) => <div key={idx} className="grid grid-cols-2 hover:bg-gray-50/30 transition-colors" data-id="element-81">
                <div className="p-4 bg-red-50/50 flex items-start gap-3" data-id="element-82">
                  <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-83" />
                  <p className="text-sm text-gray-700" data-id="element-84">{row.sin}</p>
                </div>
                <div className="p-4 bg-green-50/60 flex items-start gap-3 border-l border-gray-100" data-id="element-85">
                  <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-86" />
                  <p className="text-sm text-gray-800 font-medium" data-id="element-87">{row.con}</p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Mobile View — Toggle SIN/CON */}
        <div className="md:hidden" data-id="element-88">
          <div className="flex bg-gray-100 rounded-xl p-1 mb-3 gap-1" data-id="element-89">
            <button onClick={() => setView('sin')} className={`flex-1 py-2 rounded-lg text-xs font-bold uppercase tracking-wider transition-all ${view === 'sin' ? 'bg-red-500 text-white shadow' : 'text-red-600'}`} data-id="element-90">
              ❌ Sin Megapack
            </button>
            <button onClick={() => setView('con')} className={`flex-1 py-2 rounded-lg text-xs font-bold uppercase tracking-wider transition-all ${view === 'con' ? 'bg-green-500 text-white shadow' : 'text-green-600'}`} data-id="element-91">
              ✅ Con Megapack
            </button>
          </div>

          <div className={`rounded-xl border overflow-hidden transition-colors ${view === 'sin' ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'}`} data-id="element-92">
            <div className={`divide-y ${view === 'sin' ? 'divide-red-100' : 'divide-green-100'}`} data-id="element-93">
              {comparisons.map((row, idx) => <div key={idx} className="p-2.5 flex items-start gap-2" data-id="element-94">
                  {view === 'sin' ? <>
                      <X className="w-3.5 h-3.5 text-red-500 shrink-0 mt-0.5" data-id="element-95" />
                      <p className="text-[12px] text-gray-700 leading-snug" data-id="element-96">
                        {row.sin}
                      </p>
                    </> : <>
                      <Check className="w-3.5 h-3.5 text-green-600 shrink-0 mt-0.5" data-id="element-97" />
                      <p className="text-[12px] text-gray-800 font-medium leading-snug" data-id="element-98">
                        {row.con}
                      </p>
                    </>}
                </div>)}
            </div>
          </div>

          <p className="text-center text-[10px] text-gray-400 mt-2" data-id="element-99">
            Tocá las pestañas para comparar
          </p>
        </div>
      </div>
    </section>;
}